<template>
    <div class="row">
        <div class="col-12 h1-wrapper">
            <h1><slot name="maintitle"></slot></h1>
        </div>
    </div>
</template>